import { createGlobalStyle } from 'styled-components/macro';

export const GlobalDevStyle = createGlobalStyle`
  :root {
    /* stylelint-disable-next-line */
    font-size: 10px;
  }
`;
